import React from "react";
import TextAreaAutosize from 'react-textarea-autosize';
import { WithTranslation, withTranslation } from "react-i18next";
import { IOperationData, TranslationKeyType, IListTextInputOperation, IlistInputOperation } from "../../../constants/types";
import './ListTextInputOperation.scss'
import { validateAddress } from '../../../data/apiconnect'
import eventBus from '../EventBus'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ListInputOperation from "../listInputOperation/ListInputOperation";

interface Props extends WithTranslation {
    operation: IListTextInputOperation,
    data: IOperationData,
    onChange: (changes: IOperationData) => void
};

interface State {
    errorText: any;
    showSuggModal: boolean;
    addressSuggestions: any;
    chosenSuggestion: any;
};

class ListTextInputOperation extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            errorText: {},
            showSuggModal: false,
            addressSuggestions: null,
            chosenSuggestion: null,
        }
    }

    componentDidMount() {
        eventBus.on("onNextValidate", this.validateAllInputs);
    }

    componentWillUnmount(): void {
        eventBus.remove("onNextValidate", this.validateAllInputs)
    }

    onChange = (e: React.ChangeEvent<HTMLTextAreaElement>, key: string, inputMode: any, maxLen: number) => {
        const { data, onChange, operation } = this.props;
        const value = e.target.value;
        if ((inputMode == 'numeric' || inputMode == 'tel') && !Boolean(/^$|[0-9.,-]+$/.test(value))) return;
        if (inputMode == 'text' && (key != "address" && key != "orgName") && !Boolean(/^$|[^0-9]+$/.test(value))) return;
        if (value.length > maxLen) return;

        const ok = true;
        onChange({
            ...data,
            value: {
                ...data.value, [key]: { value: value, OK: ok }
            },
            OK: true //validates happens on "next" click
        });
    }

    validateStandardInputs = () => {
        const { data, operation, t } = this.props;
        let passAllChecks = true;
        let errorText = {};
        operation.options.forEach(op => {
            if (!data?.value?.[op.key] && op.validationType != 'none') {
                errorText = { ...errorText, [op.key]: "general.error-empty" }
                if (op.validationType != 'asAddress') passAllChecks = false && passAllChecks;
                return;
            }

            let check;
            let value = data?.value?.[op.key]?.value;
            switch (op.validationType) {
                case "asFreeText":
                    check = value != "";
                    if (!check)
                        errorText = { ...errorText, [op.key]: "general.error-empty" }
                    passAllChecks = check && passAllChecks;
                    break;
                case "asEmail":
                    check = this.validateEmail(value);
                    if (!check)
                        errorText = { ...errorText, [op.key]: "general.error-email" }
                    passAllChecks = Boolean(check) && passAllChecks;
                    break;
                case "asPNumber":
                    check = this.validatePNumber(value);
                    if (!check)
                        errorText = { ...errorText, [op.key]: "general.error-person-nr" }
                    passAllChecks = Boolean(check) && passAllChecks;
                    break;
                case "asPhone":
                case "asNumeric":
                    check = value != "";
                    if (!check)
                        errorText = { ...errorText, [op.key]: "general.error-empty" }
                    passAllChecks = check && passAllChecks;
                    break;
                case "asAddress":
                    check = value != "";
                    if (!check)
                        errorText = { ...errorText, [op.key]: "general.error-empty" }
                    break;
                case "none":
                default:
            }
        });
        return { errorText, passAllChecks }
    }

    validateAllInputs = async (onNext: any) => {
        const { data, onChange, operation } = this.props;

        let { errorText, passAllChecks } = this.validateStandardInputs();
        let checkAddress = false;
        operation?.options.forEach(op => { if (op.key == 'address') checkAddress = true })

        if (checkAddress) {
            //if atleast one address field is missing input
            // let noAddressErr = Object.keys(errorText).reduce((acc, curr) => !['address', 'zipCode', 'city'].includes(curr) && acc, true)

            //if all address fields are missing input
            let noAddressErr = Object.keys(errorText).filter(value => ['address', 'zipCode', 'city'].includes(value)).length != 3;

            passAllChecks = passAllChecks && noAddressErr;
            if (passAllChecks) {
                const res = await validateAddress({
                    "street": data?.value?.address?.value,
                    "postcode": data?.value?.zipCode?.value,
                    "locality": data?.value?.city?.value
                });

                if (res?.status != 401) {

                    if (!res.is_valid) {
                        passAllChecks = false;
                        if (res?.suggestions?.length) {
                            this.setState({ addressSuggestions: res?.suggestions }, () => {
                                this.setState({ showSuggModal: true })
                            })
                        } else {
                            errorText = {
                                ...errorText,
                                address: "general.error-address",
                                zipCode: "general.error-address",
                                city: "general.error-address",
                            }
                        }
                    }
                }
            }
        }

        this.setState({ errorText }, () => {
            if (passAllChecks)
                onNext();
        })

    }

    validatePNumber = (pNumber: string) => {
        return String(pNumber)
            .toLowerCase()
            .match(
                /^[0-9][0-9][- ]?((0[0-9])|(10|11|12))[- ]?(([0-2][0-9])|(3[0-1])|(([7-8][0-9])|(6[1-9])|(9[0-1])))[- ]?[0-9]{4}$/
            );
    };

    validateEmail = (email: string) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    formatSuggestions(suggestions: any) {
        return suggestions.map((sugg: any, i: number) =>
            ({ key: `${i}`, text: `${sugg.street} ${sugg?.street_number || ''}${sugg?.letter || ''}, ${sugg.postcode} ${sugg.locality}` })
        )
    }


    handleClose = () => { this.setState({ showSuggModal: false, chosenSuggestion: null, addressSuggestions: null }) }

    handleChosenSugg = async () => {
        const { chosenSuggestion, showSuggModal, addressSuggestions } = this.state;
        const { onChange, data } = this.props;
        if (chosenSuggestion == null || chosenSuggestion == undefined) this.handleClose()
        const i = +chosenSuggestion?.value;
        const suggestObj = {
            address: { value: `${addressSuggestions[i].street} ${addressSuggestions[i].street_number}${addressSuggestions[i]?.letter || ''}`, OK: true },
            zipCode: { value: `${addressSuggestions[i].postcode}`, OK: true },
            city: { value: `${addressSuggestions[i].locality}`, OK: true },
        }

        await onChange({ 
            ...data,
            value: {
                ...data.value, ...suggestObj,
            },
            OK: true
        });

        let { errorText, passAllChecks } = this.validateStandardInputs();
        this.setState({ errorText }, () => {
            this.handleClose()
        })
    }

    renderErrorInformation(key: any) {
        const { t } = this.props;
        const { errorText } = this.state;
        return errorText?.[key] ?
            <div
                className="card-to-list-suggestion fade-in"
                style={{
                    marginTop: "0rem",
                    backgroundColor: "#d62828",
                    color: "white",
                    padding: "0.5rem",
                    fontWeight: "10px",
                    borderRadius: "0.25rem",
                }}>
                {t(errorText[key] as unknown as TemplateStringsArray)}
            </div > : <></>
    }


    renderInputFields = () => {
        const { t, operation, data } = this.props;
        const renderInputs = operation.options.map(option => {
            return (<div key={option.key as any}>
                <p className="list-text-input-description fade-in">{t(option.label as unknown as TemplateStringsArray)}</p>
                <TextAreaAutosize
                    inputMode={option.inputMode}
                    aria-required={true}
                    placeholder={t("general.write-here")}
                    value={data?.value ? (data?.value[option.key] ? data?.value?.[option.key]?.value : '') : ''}
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }}
                    onChange={(e) => { this.onChange(e, option.key, option.inputMode, option.maxLen) }}
                    className="text-input-input" />
                <div className="text-input-divider" />
                {this.renderErrorInformation(option.key)}
            </div>
            )
        })
        return renderInputs;
    }

    render() {
        const { t, operation, data } = this.props;
        const { chosenSuggestion, showSuggModal, addressSuggestions } = this.state;

        const desc = this.props.operation.description

        return <div className="render-list-text-input-operation">
            {desc ? <div>{t(desc as unknown as TemplateStringsArray)}</div> : null}
            {this.renderInputFields()}

            {showSuggModal &&
                <Modal show={showSuggModal} onHide={this.handleClose}>
                    <Modal.Header closeButton >
                        <Modal.Title>
                            {t("general.error-address")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <ListInputOperation
                            operation={
                                {
                                    type: "LIST-INPUT",
                                    description: "general.suggestion",
                                    suggestions: this.formatSuggestions(addressSuggestions) as any,//sst choice
                                    next: {
                                        valueSource: ["value"],
                                        cases: {
                                            default: 0
                                        }
                                    }
                                }}

                            data={chosenSuggestion}
                            onChange={(choice) => {
                                this.setState({ chosenSuggestion: choice })
                            }} />

                    </Modal.Body>
                    <Modal.Footer >
                        <Button variant="secondary" onClick={this.handleClose}>
                            {t("general.close")}
                        </Button>
                        <Button className="list-text-input-button-modal" onClick={this.handleChosenSugg} disabled={!chosenSuggestion}>
                            {t("general.choose")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            }

        </div>;
    }
};

export default withTranslation()(ListTextInputOperation);